import React, { useEffect, useState } from 'react';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
type Buyer = {
  name: string;
  city: string;
  country: string;
};
const BUYERS: Buyer[] = [{
  name: 'Rachel',
  city: 'Manchester',
  country: 'United Kingdom'
}, {
  name: 'Karen',
  city: 'Auckland',
  country: 'New Zealand'
}, {
  name: 'Andrea',
  city: 'Calgary',
  country: 'Canada'
}, {
  name: 'Melissa',
  city: 'Brisbane',
  country: 'Australia'
}, {
  name: 'David',
  city: 'Edinburgh',
  country: 'United Kingdom'
}, {
  name: 'Sophie',
  city: 'Wellington',
  country: 'New Zealand'
}, {
  name: 'Jessica',
  city: 'Toronto',
  country: 'Canada'
}, {
  name: 'Emily',
  city: 'Melbourne',
  country: 'Australia'
}, {
  name: 'Laura',
  city: 'Bristol',
  country: 'United Kingdom'
}, {
  name: 'Chloe',
  city: 'Christchurch',
  country: 'New Zealand'
}, {
  name: 'Isla',
  city: 'Vancouver',
  country: 'Canada'
}, {
  name: 'Grace',
  city: 'Perth',
  country: 'Australia'
}, {
  name: 'Ruby',
  city: 'Montreal',
  country: 'Canada'
}, {
  name: 'Olivia',
  city: 'Sydney',
  country: 'Australia'
}, {
  name: 'Hannah',
  city: 'Leeds',
  country: 'United Kingdom'
}];
const MINUTES = [2, 3, 5, 7, 8, 11, 14, 18];
export function PurchasePopup() {
  const [index, setIndex] = useState<number>(0);
  const [visible, setVisible] = useState<boolean>(false);
  const [dismissed, setDismissed] = useState<boolean>(false);
  useEffect(() => {
    if (dismissed) return;
    let hideId = 0;
    const showId = window.setInterval(() => {
      setVisible(true);
      hideId = window.setTimeout(() => {
        setVisible(false);
        setIndex(prev => (prev + 1) % BUYERS.length);
      }, 5000);
    }, 9000);
    const firstId = window.setTimeout(() => setVisible(true), 3500);
    return () => {
      window.clearInterval(showId);
      window.clearTimeout(hideId);
      window.clearTimeout(firstId);
    };
  }, [dismissed]);
  if (dismissed || !visible) return null;
  const buyer = BUYERS[index];
  const minutes = MINUTES[index % MINUTES.length];
  return <div role="status" aria-live="polite" className="animate-pop-in fixed bottom-2 left-2 z-50 max-w-[240px] rounded-xl border-2 border-orange bg-white p-2 pr-6 shadow-lg sm:max-w-[270px]" data-id="element-213" data-mp="2aqxlsogkcif9">
      <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="absolute right-1 top-1 rounded-full p-0.5 text-muted transition-colors duration-150 ease-out hover:bg-soft hover:text-navy" data-id="element-214" data-mp="2kko6di9kk8po">
        <XIcon className="h-3 w-3" aria-hidden="true" data-id="element-215" data-mp="1wwwtodk49tnv" />
      </button>

      <div className="flex items-start gap-2" data-id="element-216" data-mp="1wv25mqdjtlfk">
        <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-green/15" data-id="element-217" data-mp="21vzsvhdf15nx">
          <CheckCircle2Icon className="h-4 w-4 text-green" aria-hidden="true" data-id="element-218" data-mp="26o16p7q8f4g2" />
        </span>
        <div data-id="element-219" data-mp="196j2ep9cvyuc">
          <p className="text-[11px] font-bold leading-tight text-navy" data-id="element-220" data-mp="1972jy4v3gl7u">
            {buyer.name} from {buyer.city}, {buyer.country}
          </p>
          <p className="text-[11px] leading-snug text-muted" data-id="element-221" data-mp="3rgyczcn362cg">
            just purchased <span className="font-bold text-green-dark" data-id="element-222" data-mp="3reubt2gknhfv">Kids Learning Ready™</span>
          </p>
          <p className="text-[9px] uppercase tracking-wide text-muted/80" data-id="element-223" data-mp="3nd8t30hcw8xr">
            {minutes} minutes ago · Verified
          </p>
        </div>
      </div>
    </div>;
}